import { z } from "zod";
import { schemaRawAccount } from "../../accounts";
const schemaAccountRequestParams = z.object({
    currencyIds: z.array(z.string()).optional(),
    showAccountFilter: z.boolean().optional(),
});
const schemaAccountRequestResults = z.object({
    rawAccount: schemaRawAccount,
});
export const schemaAccountRequest = {
    params: schemaAccountRequestParams,
    result: schemaAccountRequestResults,
};
//# sourceMappingURL=AccountRequest.js.map